import Image from "next/image";
import { useAuthValue } from "@/contexts/contextAuth";
import { isMobileDevice, setScrollHidden } from "@/libs/utils";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";

type Props = { vehicleData: any };

const AdditionalServices = ({ vehicleData }: Props) => {
  const { setIsSignup, setSource, setRedirectUrl } = useAuthValue();

  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    setIsMobile(isMobileDevice());
  }, []);

  const router = useRouter();

  const handleButtonClick = (action: any) => {
    action(router);
  };
  const { vinNumber, Zip, Mileage } = vehicleData;

  const services = [
    {
      active: true,
      imagePath: "/assets/services/shippingService.svg",
      serviceTitle: "Shipping",
      buttonText: "See details",
      subText:
        "Ship this vehicle anywhere in the united states using Runbuggy shipping. Enter in your delivery ZIP to get a quote. ",
      buttonAction: (router: any) => {
        window?.dataLayer &&
          window.dataLayer.push({
            event: "Shipping Get Quote",
            Login: "pre",
          });
        const navigationUrl = `/transport/cars`;
        router.push(navigationUrl);
      },
    },
    {
      active: true,
      imagePath: "/assets/services/insuranceService.svg",
      serviceTitle: "Insurance",
      buttonText: "Get quote",
      subText:
        "Compare, switch, and save on auto insurance. Get digital quotes across multiple providers without the need to speak with several agents.",
      buttonAction: (router: any) => {
        window?.dataLayer &&
          window.dataLayer.push({
            event: "Insurance Get Quote",
            Login: "pre",
          });
        const navigationUrl = `https://insurify.com/start/auto/partner/privateauto/?utm_source=privateauto&utm_medium=auto&utm_campaign=marketingvdp `;
        window.open(navigationUrl, "_blank");
      },
    },
    {
      active: true,
      imagePath: "/assets/services/warrantyService.svg",
      serviceTitle: "Protection",
      buttonText: "See details",
      subText:
        "Don't wait to protect your car until it's too late. Get your vehicle covered with service protection to stay ahead of car problems.",
      buttonAction: () => {
        window?.dataLayer &&
          window.dataLayer.push({
            event: "Protection See Details",
            Login: "pre",
          });
        const navigationUrl = `http://app.chaiz.com/cards?vin=${vinNumber}&zip=${Zip}&searchMileage=${Mileage}&utm_source=affiliate&utm_medium=cps&utm_campaign=pauto`;
        window.open(navigationUrl, "_blank");
      },
    },
    {
      active: true,
      imagePath: "/assets/services/mechanicsService.svg",
      serviceTitle: "Inspection",
      buttonText: "See details",
      subText:
        "Inspect your car yourself. Connect the OBD-II device for real-time monitoring of the vehicle diagnostics, performance, and emissions.",
      buttonAction: () => {
        window?.dataLayer &&
          window.dataLayer.push({
            event: "Inspection See Details",
            Login: "pre",
          });
        setSource("SERVICES");
        setRedirectUrl("/services/inspection");
        setIsSignup(true, { redirectUrl: "/services/inspection" });
      },
    },
  ];

  return (
    <div>
      <div className="flex items-center text-xl sm:text-3xl font-bold mt-8 px-4 md:px-0">
        Add-on Services
      </div>

      <div className="px-4 md:px-0">
        {services.map((service, index) => (
          <div
            key={index}
            className={`w-full  md:w-[820px] h-[145px] md:h-[134px] flex-shrink-0 rounded-[7px] border border-[#D3D3D3] my-5   ${
              service.active ? "bg-white" : "bg-[#F9F9F9]"
            }`}
          >
            <div className="flex justify-between items-center mx-4 mt-4">
              <div className="items-center pr-4 flex">
                <Image
                  width={isMobile ? 50 : 70}
                  height={isMobile ? 50 : 70}
                  src={service.imagePath}
                  alt="null"
                  className={` mr-2 w-[${
                    isMobile ? "70px pr-3" : "70px px-3"
                  }] h-[${isMobile ? "50px" : "70px"}]`}
                />
                {isMobile && (
                  <div className="text-[18px] ml-2 font-normal font-semibold leading-[36px]">
                    {service.serviceTitle}
                  </div>
                )}
                <div className="m-2 md:max-w-[442px]">
                  <div className="flex">
                    {!isMobile && (
                      <div className="text-[18px] font-normal font-semibold leading-[36px]">
                        {service.serviceTitle}
                      </div>
                    )}

                    {!service.active && (
                      <div className="rounded-[17px] h-[20px] ml-4 mt-2 border border-[#27AE60] bg-[rgba(30,222,0,0.08)] text-[#27AE60] ] text-[10px] font-normal font-semibold leading-[16px] tracking-[0.4px] uppercase px-1 flex items-center">
                        coming soon
                      </div>
                    )}
                  </div>
                  {!isMobile && (
                    <div className="text-[14px] text-[#808080] font-normal font-medium leading-[20.5px]">
                      {service.subText}
                    </div>
                  )}
                </div>
              </div>

              {service.active && (
                <div className="w-[130px]">
                  <button
                    className="bg-[#f7f9fc] hover:bg-slate-200 py-2 md:py-3 px-3 rounded cursor-pointer text-[14px] font-normal font-medium leading-[16px]"
                    onClick={() => handleButtonClick(service.buttonAction)}
                  >
                    {service.buttonText}
                  </button>
                </div>
              )}
            </div>
            {isMobile && (
              <div className="flex justify-between items-center mx-4">
                <div className="text-[14px] text-[#808080] font-normal font-medium leading-[20.5px]">
                  {service.subText}
                </div>
              </div>
            )}
          </div>
        ))}

        <button
          className="btn-outline-primary"
          onClick={() => {
            setSource("SERVICES");
            setRedirectUrl("/services/shipping");
            setIsSignup(true, { redirectUrl: "/services/shipping" });
            setScrollHidden();
          }}
        >
          Go to services Hub
        </button>
      </div>
    </div>
  );
};

export default AdditionalServices;
